import { SET_ROLES } from "redux/constants/portal";

const initialState = {
  roles: [],
};

const roles = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ROLES:
      return {
        ...state,
        roles: payload,
      };
  }
  return state;
};

export default roles;
